/** @jsxImportSource @emotion/react */
import React from "react";
import { css } from "@emotion/react";
import { Img } from "react-image";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'

export default function CustomImage({ children, style, width, height, src, alt, borderRadius, skeletonWidth, ...rest }) {
  return (
    <Img width={width} height={height} style={{borderRadius: borderRadius,objectFit: "cover",...style}}
        src={src}
        alt={alt}
        loader={<Skeleton width={width || skeletonWidth} height={height} borderRadius={borderRadius}/>}
        unloader={<Skeleton width={width || skeletonWidth} height={height} borderRadius={borderRadius}/>}
        {...rest}
    />
  )
}
